var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('v-img',{staticClass:"mx-auto",attrs:{"max-width":"50%","src":require("../../../public/img/success.svg")}}),_c('h1',{staticClass:"text-center mt-5 text-h3"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"text-center mt-2 text-h5"},[_vm._v(_vm._s(_vm.text))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }